import React, { useState } from 'react';
import { supabase, supabaseEnabled } from '../../lib/supabase';

// ──────────────────────────────────────────────────────────────────────
// EmailVerifyBanner — gentle nag, not blocking.
// Visible only when:
//   • Supabase user exists
//   • email_confirmed_at is null
//   • > 7 days since signup (created_at)
// Can resend the confirmation email.
// ──────────────────────────────────────────────────────────────────────

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

export default function EmailVerifyBanner({ user, onDismiss }) {
  const [hidden, setHidden] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  if (!user || hidden) return null;
  if (user.email_confirmed_at) return null;

  const createdAt = user.created_at ? new Date(user.created_at).getTime() : Date.now();
  if (Date.now() - createdAt < SEVEN_DAYS_MS) return null;

  const resend = async () => {
    if (!supabaseEnabled || sending) return;
    setSending(true); setError('');
    try {
      const { error } = await supabase.auth.resend({ type: 'signup', email: user.email });
      if (error) setError(error.message);
      else setSent(true);
    } finally {
      setSending(false);
    }
  };

  return (
    <div role="status" aria-live="polite" style={{
      position: 'sticky', top: 0, zIndex: 50,
      background: '#FEF3C7', borderBottom: '1px solid #F59E0B',
      color: '#78350F', padding: '8px 16px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: 12, fontSize: 13, fontWeight: 600,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
    }}>
      <span>
        {sent
          ? '✓ Verification email sent — check your inbox.'
          : 'Please verify your email to keep your trial active. Check your inbox or '}
        {!sent && (
          <button onClick={resend} disabled={sending} style={{
            background: 'none', border: 'none', textDecoration: 'underline',
            color: '#78350F', fontWeight: 800, cursor: sending ? 'wait' : 'pointer',
            padding: 0, fontSize: 13, fontFamily: 'inherit',
          }}>
            {sending ? 'sending…' : 'resend'}
          </button>
        )}.
        {error && <span style={{ marginLeft: 8, color: '#B91C1C' }}>· {error}</span>}
      </span>
      <button onClick={() => { setHidden(true); onDismiss?.(); }} aria-label="Dismiss"
        style={{ background: 'none', border: 'none', color: '#78350F', cursor: 'pointer', fontSize: 16, padding: 0 }}>
        ×
      </button>
    </div>
  );
}
